import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';
import { Typography } from '@shared/ui/typography/typography';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
`;

export const IconWrapper = styled('div')`
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    justify-content: center;
`;

export const Title = styled(Typography)`
    margin-bottom: 12px;
`;

export const Description = styled(Typography)`
    margin-bottom: 28px;
`;

export const StyledLink = styled(LinkScroll)`
    display: flex;
    width: 100%;
`;
